
$(document).on("change", 'body .product-option__input', function(e) { 
$("#refresh-stock_main").load(location.href + " #refresh-stock_refresh");
setTimeout(function () {
$("#refresh-stock_main").load(location.href + " #refresh-stock_refresh");
}, 500);
setTimeout(function () {
$("#refresh-stock_main").load(location.href + " #refresh-stock_refresh");
}, 1000);
setTimeout(function () {
$("#refresh-stock_main").load(location.href + " #refresh-stock_refresh");
}, 1500);
});

$(document).on("change", '.size_option_custom', function(e) { 
$('input[name="filter.v.availability"]').eq(0).trigger('click').prop('checked', true);
});


$(document).ready(function(){
  $(function(){
   $(window).bind("resize",function(){
 
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
$('body').addClass('mobile_menu_active');
} else {
$('body').removeClass('mobile_menu_active');
}
   }).resize();
});
  
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
$('body').addClass('mobile_menu_active');
} else {
$('body').removeClass('mobile_menu_active');
}
});




/* cart warning hide show */
(function() {
  const originalFetch = window.fetch;

  window.fetch = async function(resource, config) {
    const isAdd = typeof resource === "string" && resource.includes("/cart/add.js");
    const isChange = typeof resource === "string" && resource.includes("/cart/change.js");
    const isUpdate = typeof resource === "string" && resource.includes("/cart");
    
    const response = await originalFetch(resource, config);

    // ADD.JS event
    if (isAdd && response.ok) {
      document.dispatchEvent(new CustomEvent("cart:add-success"));
    }

    // CHANGE event
    if (isChange && response.ok) {
      document.dispatchEvent(new CustomEvent("cart:changed"));
    }

    // UPDATE event (cart drawer reload, cart refresh, etc.)
    if (isUpdate && response.ok) {
      document.dispatchEvent(new CustomEvent("cart:updated"));
    }

    return response;
  };
})();

document.addEventListener("cart:updated", function () {
  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      const itemCount = cart.item_count;
      const cartInfo = document.querySelector(".custom_cart_info");
      if (!cartInfo) return;

      if (itemCount > 0) {
        cartInfo.style.display = "flex";
      } else {
        cartInfo.style.display = "none";
      }
    })
    .catch(err => console.error("Cart fetch error:", err));
});



window.addEventListener("scroll", () => {
  if (window.scrollY > 200) {
    document.body.classList.add("scrolled");
  } else {
    document.body.classList.remove("scrolled");
  }
});


jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});
